import React from 'react'
import {Flex, Text, Image, Box, useMultiStyleConfig} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

export default function ErrorAndMaintenancePage() {
    const styles = useMultiStyleConfig('ErrorAndMaintenancePage', {})
    const {errorPage} = styles

    return (
        <Flex {...errorPage?.pageContainer} data-status-code="503">
            <Flex {...errorPage?.messageContainer}>
                <Flex {...errorPage?.messageTextContainer}>
                    <Text {...errorPage?.messageTitle}>
                        <FormattedMessage
                            id="maintenance_page_message.title"
                            defaultMessage="We’re Making Improvements"
                        />
                    </Text>
                    <Text {...errorPage?.messageText}>
                        <FormattedMessage
                            id="maintenance_page_message.message"
                            defaultMessage="Our website is currently undergoing scheduled maintenance to provide you with a better experience."
                        />
                    </Text>
                </Flex>
                <Box {...errorPage?.imageContainer}>
                    <Image
                        {...errorPage?.imageElement}
                        alt="an image of a product"
                        src={getAssetUrl('static/img/maintenanceImage.png')}
                    />
                </Box>
            </Flex>
        </Flex>
    )
}
